export default {
  apiKey: "AIzaSyC9_irp88urWg8LXX9pFLoTS4PApjZRuIk",
  authDomain: "bancoazteca-middleware.firebaseapp.com",
  databaseURL: "https://bancoazteca-middleware.firebaseio.com",
  projectId: "bancoazteca-middleware",
  storageBucket: "bancoazteca-middleware.appspot.com",
  messagingSenderId: "841674675930",
  appId: "1:841674675930:web:e917b5971d5bd8b5"
};
